import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getSuppliers } from "../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import { getSessionData } from "../../base/helper/baseHelper";
import Base from "../../base/views/base";
import SelectableSearch from "../../base/views/SelectableSearch";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import { generateSaleableReturnReconcillationReport } from "../helper/reportHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
      widht: "100%",
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
}));

function SaleableReturnReconcilationReport(props) {
  const classes = useStyles();

  const [userId, setUserId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [gridData, setGridData] = React.useState([]);
  const [supplierData, setSupplierData] = React.useState({
    load: false,
    values: [],
  });
  const [reportState, setReportState] = React.useState({
    user_id: userId,
    store_id: storeId,
    selectedSupplier: { id: 0, optionname: "" },
    ra_number: "",
  });
  const [errors, setErrors] = React.useState({});

  // eslint-disable-next-line

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    // eslint-disable-next-line
  }, [userId, storeId]);

  const loadReport = (e) => {
    e.preventDefault();
    if (validateReport()) {
      var strSupplier =
        reportState.selectedSupplier.optionname !== undefined
          ? reportState.selectedSupplier.optionname
          : "";

      generateSaleableReturnReconcillationReport(
        userId,
        storeId,
        strSupplier,
        reportState.selectedSupplier.id,
        reportState.ra_number
      )
        .then((response) => {
          if (response && response.length > 0) {
            setGridData(response);
          } else {
            setGridData([]);
          }
        })
        .catch((err) => {});
    }
  };

  const loadSupplierDropdown = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.name,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {});
  };

  const handleSupplierChange = (event, value) => {
    if (value && value.id) {
      setReportState({
        ...reportState,
        selectedSupplier: { id: value.id, optionname: value.optionname },
      });
    } else {
      setReportState({
        ...reportState,
        selectedSupplier: {},
      });
    }
  };

  const updateField = (e) => {
    setReportState({
      ...reportState,
      [e.target.name]: e.target.value,
    });
  };

  const validateReport = (fieldValues = reportState) => {
    let temp = { ...errors };
    if ("selectedSupplier" in fieldValues) {
      temp.selectedSupplier =
        fieldValues.selectedSupplier.optionname === ""
          ? "Supplier is required"
          : "";
    }
    if ("ra_number" in fieldValues) {
      temp.ra_number = fieldValues.ra_number === "" ? "RA # is required" : "";
    }
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="Saleable Return RA Reconcilation Report">
        <CssBaseline />
        <Grid container spacing={2} style={{ marginTop: "1.5%" }}>
          <Grid item xs={12} sm={4}>
            <TextField
              autoFocus
              value={reportState.ra_number}
              autoComplete="ra_number"
              name="ra_number"
              variant="standard"
              required
              fullWidth
              id="ra_number"
              label="Enter your RA number"
              className={classes.submit}
              onChange={updateField}
              {...(errors.ra_number && {
                error: true,
                helperText: errors.ra_number,
              })}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <div style={{ paddingTop: 25 }}>
              <SelectableSearch
                value={reportState.selectedSupplier}
                data={supplierData}
                name="supplier"
                label="Supplier"
                id="supplier"
                loading={loadSupplierDropdown}
                onChangeEvent={handleSupplierChange}
                variantType="standard"
                {...(errors.selectedSupplier && {
                  error: true,
                  helperText: errors.selectedSupplier,
                })}
              ></SelectableSearch>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              onClick={(e) => {
                loadReport(e);
              }}
              fullWidth={true}
              color="primary"
              variant="contained"
              size="medium"
              style={{
                marginTop: "7%",
                backgroundColor: "rgb(22, 177, 255)",
                borderRadius: "0.5rem",
              }}
            >
              Generate
            </Button>
          </Grid>
        </Grid>
        <div className={classes.root}>
          <MaterialTable
            title=""
            columns={[
              {
                title: "RA #",
                field: "rano",
                defaultSort: "asc",
              },
              { title: "Supplier", field: "supplier" },
              { title: "Tote #", field: "tote" },
              {
                title: "Description",
                field: "description",
                cellStyle: { width: "25%" },
              },
              { title: "NDC", field: "ndc" },
              { title: "Scanned Qty", field: "saleablereturnqty" },
              { title: "RA Qty", field: "raqty" },
              { title: "Variance", field: "variance" },
            ]}
            data={gridData}
            options={{
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
              exportButton: true,
              exportAllData: true,
            }}
          />
        </div>
        {/* </Container>
        </Container> */}
        <LandingPageFooter />
      </Base>
    </div>
  );
}

const mapStateToDispatch = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(SaleableReturnReconcilationReport);
